exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uk-border-rounded-top {\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n.sp-product-grid-item {\n    min-width: 223px;\n}\n.sp-product-table-image {\n    width: 60px;\n}\n.sp-product-table-td {\n    padding: 0;\n}\n.sp-product-table-container {\n    /* padding: 10px 12px 0 0; */\n}\n\n/* padding */\n.padding-bottom-60 {\n    padding-bottom: 60px !important;\n}\n\n/* border */\n.border-bottom-5 {\n    border-bottom-right-radius: 5px;\n    border-bottom-left-radius: 5px;\n}\n.sp-border-light-grey {\n    border: 1px solid #F0F0F0;\n}\n", ""]);

// exports
